@if ((hasFailedUploads | async) || (hasPendingUploads | async)) {
  <a (click)="navigate()">
    <zenith-icon
      zn-icon-name="switch"
      [attr.zn-appearance]="(hasFailedUploads | async) ? 'error': (hasPendingUploads | async) ? 'update' : 'neutral'"
      [ngClass]="{
      'fade-in-out-loop': hasPendingUploads | async,
    }" />
  </a>
}
